<template>
  <div class="media-style-container" :class="contentType === '3D' ? 'media-style-threeD-container' : ''">
    <div
      class="media-title"
      :style="{
        fontFamily: content.titleStyle.fontFamily || '',
        fontSize: (content.titleStyle.fontSize + 'rem') || '',
        lineHeight: (content.titleStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.titleStyle.fontWeight || '',
        textDecoration: content.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.titleStyle.textAlign || '',
        color: content.titleStyle.color || '',
        backgroundColor: content.titleStyle.backgroundColor || '',
      }"
      v-html="content.title"
    ></div>
    <div
      class="media-button"
      @click.stop="(e) => {
        findChapterFrom(e)
        $emit('dialogOpen')
      }"
    >{{ contentType === '3D' ? '点击查看' : '点击播放' }}</div>
  </div>
</template>

<script>
/**
 * 
 * 机械制图的视频、3D模型单个样式 点击查看弹窗播放
 */
export default {
  name: "mediaStyle1",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    contentType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      
    }
  }
}
</script>

<style lang="scss" scoped>
.media-style-container{
  width: 100%;
  height: 120rem;
  background: url("~@/assets/images/books/book1/video-back.png") center no-repeat;
  background-size: contain;
  position: relative;

  .media-title{
    width: 330rem;
    max-height: 64rem;
    line-height: 32rem;
    font-size: 28rem;
    color: #0E60FF;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 156rem;
    transform: translateY(-50%);
    margin-top: 15rem;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: pre-wrap;
  }

  .media-button{
    position: absolute;
    top: 51rem;
    right: 24rem;
    line-height: 50rem;
    font-size: 24rem;
    color: #0E60FF;
    cursor: pointer;
    padding-right: 50rem;
  }
}
.media-style-threeD-container{
  background-image: url("~@/assets/images/books/book1/threeD-back.png");
}
</style>